import React, {useContext, useEffect, useState} from "react";
import {
  Layout,
  Col,
  Row,
  Divider,
  List,
  Typography,
  Table,
  Tag,
  Space,
  Form,
  Checkbox,
  Button,
  Input,
  Image,
  Select,
  Modal,
} from "antd";
import { Content } from "antd/lib/layout/layout";
import { CloseOutlined } from "@ant-design/icons";
import EvaluaarProyectoFormNotaModelForm from "./EvaluaarProyectoFormNotaModelForm";
import apiJurados from "../../../../api/Jurados/api-jurados";
import { openNotification } from "../../../../utils/Notifactions";
import apiPostulaciones from "../../../../api/Postulaciones/api-postulaciones";
import apiParticipantes from "../../../../api/Participantes/api-participantes";
import {TemplateContext} from "../../../../utils/template_context";
export default function EvaluaarProyectoFormNotaModel(props: any) {
  const [criterios, setCriterios] = useState<any>();
  /* 
   */
  /*   setCriterios(response); */
  const [isTerm, setTerm] = useState<any>(false);
  const [editFormModel, setEditFormModel] = useState<any>(false);
  const [updateData, setUpdateData] = useState<any>();
  const [dataArray, setDataArray] = useState<any>();
  const [modalType, setModalType] = useState<any>("add");
  const [activeedit, setActiveedit] = useState<any>();
  const [editData, setEditData] = useState<any>({});
  const [data, setData] = useState<any>({})

  //console.log('data', data);

  useEffect(() => {
    getCriterios()
  }, [props.jurado.proyecto.id_postulacion])

  const context = useContext(TemplateContext);
  const getCriterios = async () => {
    const {data} = await apiJurados.obtenerCriteriosJuradoPostulacion(props.jurado.jurado.id_jurado, props.jurado.proyecto.id_postulacion)
    return setCriterios(data)
    // return response;
  }

  const putCriterios = async () => {
    const response = await apiJurados.actualizarCriterioJurado(editData);
    return response;
  };
  const columns: any = [
    {
      title: <span className="as_tbl_hd">No.</span>,
      width: 60,
      dataIndex: "id",
      key: "id",
      fixed: context.device === "md" ? "left" : false,
      render: (text: any, record: any) => (
        <div>
          {criterios &&
            criterios
              .filter((item: any) => !item.nota && item)
              .indexOf(record) + 1}
        </div>
      ),
    },
    {
      title: <span className="as_tbl_hd">Criterios</span>,
      width: 500,
      dataIndex: "nombre",
      key: "nombre",
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: <span className="as_tbl_hd">Observaciones</span>,
      width: 500,
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any) => {
        return (
          <>
            <span>
              {
                datos.observaciones &&
                datos.observaciones.length > 75 ? `${datos.observaciones.substring(0, 75)}...` : datos.observaciones
              }
              {/* {datos.linea_convocatoria && datos.linea_convocatoria !== null
                ? lineasconvocatoria.filter((x: any) => x.idlineaconvocatoria === datos.linea_convocatoria)[0].nombre
                : null} */}
            </span>
          </>
        );
      },
    },
    {
      title: <span className="as_tbl_hd">Puntaje</span>,
      width: 100,
      dataIndex: "nota",
      key: "nota",
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: <span className="as_tbl_hd">Acciones</span>,
      key: "acciones",
      // dataIndex: "acciones",
      fixed: context.device === "lg" ? "right" : false,
      width: 90,
      //@ts-ignore
      render: (text: any, record: any, index: any) => (
        <a
          onClick={() => {
            setEditFormModel(true);
            setModalType("add");
            setEditData({
              ...text,
              index: index,
            });
            let criterio = criterios.find((x: any) => x.id === text.id);
            setData(criterio);
          }}
          className="vas--tab-link evaluar_btn"
        >
          EVALUAR
        </a>
      ),
    },
  ];
  const updatedivumns: any = [
    {
      title: <span className="as_tbl_hd">No.</span>,
      width: 60,
      dataIndex: "id",
      key: "id",
      fixed: context.device === "md" ? "left" : false,
      render: (text: any, record: any) => (
        <div>{criterios.indexOf(record) + 1}</div>
      ),
    },
    {
      title: <span className="as_tbl_hd">Criterios</span>,
      width: 500,
      dataIndex: "nombre",
      key: "nombre",
      fixed: context.device === "md" ? "left" : false,
    },
    {
      title: <span className="as_tbl_hd">Observaciones</span>,
      width: 500,
      fixed: context.device === "md" ? "left" : false,
      render: (datos: any) => {
        return (
          <>
            <span>
              {
                datos.observaciones &&
                datos.observaciones.length > 75 ? `${datos.observaciones.substring(0, 75)}...` : datos.observaciones
              }
              {/* {datos.linea_convocatoria && datos.linea_convocatoria !== null
                ? lineasconvocatoria.filter((x: any) => x.idlineaconvocatoria === datos.linea_convocatoria)[0].nombre
                : null} */}
            </span>
          </>
        );
      },
    },
    {
      title: <span className="as_tbl_hd">Puntaje</span>,
      width: 100,
      dataIndex: "nota",
      key: "nota",
      fixed: context.device === "md" ? "left" : false,
      summary: (pageData) => {
        // Calcula el total de notas en la página actual
        const total = pageData.reduce((acc, item) => acc + item.nota, 0);
        return <span>Total: {total}</span>;
      },
    },
    {
      title: <span className="as_tbl_hd">Acciones</span>,
      key: "acciones",
      fixed: context.device === "lg" ? "right" : false,
      width: 90,
      //@ts-ignore
      render: (text: any, record: any, index: any) => (
        <a
          onClick={() => {
            // setActiveedit(index)
            setModalType("edit");
            setEditFormModel(true);
            setEditData({
              ...text,
              index: index,
            });
            let criterio = criterios.find((x: any) => x.id === text.id);
            setData(criterio);
          }}
          className="vas--tab-link"
        >
          EDITAR
        </a>
      ),
    },
  ];
  function setUpdatedval(params: any) {
    var data = criterios;
    data[activeedit] = editData;
  }
  
  const hanldeClick =(e:any) =>{
    
    e.preventDefault()

    getCriterios()
    
    //  setCriterios(criterios)
    // console.log(criterios, ' criterio')
  }
  

  return (
    <div>
      {editFormModel ? (
        <EvaluaarProyectoFormNotaModelForm
          putCriterios={putCriterios}
          setEditFormModel={setEditFormModel}
          editData={editData}
          setEditData={setEditData}
          setUpdateData={setUpdateData}
          updateData={updateData}
          modalType={modalType}
          activeedit={activeedit}
          setUpdatedval={setUpdatedval}
          dataArray={[data]}
          setDataArray={setDataArray}
          hanldeClick={hanldeClick}
        />
      ) : (
        <div>
          <div style={{ background: "white", borderRadius: "15px" }}>
            <Layout
              className=" container-fluid mb-2 model_info"
              style={{ borderRadius: 15 }}
            >
              {/* 
      <Content className='model__header'>
         <Content className='mdl_header_containt'>
            <div className="row">
               <div className='col-6 p-1'>
                  <h3>Evaluacion de Proyecto</h3>
               </div>
               <div className='col-6 p-1 text-right'>
                  <a className="mdl_close_btn" onClick={() =>
                     (props.setVisible("informacionProyectosList"), props.setVisible(false))}>
                     <CloseOutlined />
                  </a>
               </div>
            </div>
         </Content>
      </Content>
      */}
              <Content className="model__header">
                <Content className="mdl_header_containt">
                  <div className="mdl_heading_row">
                    <div className="col-12 evel_mdl_title font-size-14px pt-2 pb-2 title_modal_morado">
                      Evaluación de Proyecto
                    </div>
                  </div>
                </Content>
              </Content>
              <Content
                className="row evalu__top_mdl_box"
                style={{ background: "white", borderRadius: "15px" }}
              >
                <Content
                  className="evalu_inform_header"
                  style={{
                    background: "#AE3E97",
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <ul
                    className="menu_tab"
                    style={{
                      listStyle: "none",
                      background: "#AE3E97",
                      display: "flex",
                      alignItems: "center",
                      margin: "unset",
                    }}
                  >
                    <li
                      className={
                        props.evalProyectoPage == "informacionProyectosList"
                          ? "active2"
                          : ""
                      }
                    >
                      <a
                        onClick={() =>
                          props.setEvalProyectoPage("informacionProyectosList")
                        }
                      >
                        Información del proyecto
                      </a>
                    </li>
                    <li
                      className={
                        props.evalProyectoPage === "evaluaarProyectoForm"
                          ? "active2"
                          : ""
                      }
                    >
                      <a
                        onClick={() =>
                          props.setEvalProyectoPage("evaluaarProyectoForm")
                        }
                      >
                        Evaluar proyecto
                      </a>
                    </li>
                  </ul>
                </Content>
                <Content
                  className="evalu_listing evolv_mdl_box"
                  style={{ padding: 20 }}
                >
                  <div className=" row">
                    <div className="col-12 pb-3">
                      <p className="title_evaluar">
                        Seleccione el criterio de evaluación y a continuación
                        asigne la nota. Para finalizar debes evaluar todos los
                        criterios.
                      </p>
                    </div>
                    <div className="col-10">
                      <span className="title_evaluar font-family-Montserrat-Regular">
                        Criterios de evaluación en 0
                      </span>
                    </div>
                    <div className="col-2 d-flex justify-content-end">
                      <p className="table--total table--total-mdl">
                        Total:{" "}
                        <span
                          className="text-orance"
                          style={{ color: "orange" }}
                        >
                          {criterios &&
                            criterios.filter((item: any) => !item.nota && item)
                              ?.length}
                        </span>
                      </p>
                    </div>
                    <div className="col-12 pt-2">
                      <hr className="no-margin" />
                    </div>
                  </div>
                  <Table
                    columns={columns}
                    dataSource={
                      criterios &&
                      criterios.filter((item: any) => !item.nota && item)
                    }
                    scroll={{ x: 900 }}
                    pagination={false}
                    rowClassName={(record, index) =>
                      index % 2 === 0 ? "table-row-dark" : "table-row-light"
                    }
                  />
                </Content>
              </Content>
            </Layout>
          </div>
          <div style={{ background: "white", borderRadius: "15px" }}>
            <Layout
              className=" container-fluid mb-1 model_info"
              style={{ borderRadius: 15 }}
            >
              <Content
                className="row evalu__top_mdl_box"
                style={{ background: "white", borderRadius: "15px" }}
              >
                <Content
                  className="evalu_listing evolv_mdl_box"
                  style={{ padding: 20 }}
                >
                  <div className=" row">
                    <div className="col-10">
                      <span className="title_evaluar font-family-Montserrat-Regular">
                        Criterios evaluados
                      </span>
                    </div>
                    <div className="col-2 d-flex justify-content-end">
                      <p className="table--total table--total-mdl">
                        Total:{" "}
                        <span
                          className="text-orance"
                          style={{ color: "orange" }}
                        >
                          {criterios &&
                            criterios.filter((item: any) => item.nota && item)
                              ?.length}
                        </span>
                      </p>
                    </div>
                    <div className="col-12 pt-2">
                      <hr className="no-margin" />
                    </div>
                  </div>
                  <Table
                    columns={updatedivumns}
                    dataSource={
                      criterios &&
                      criterios.filter((item: any) => item.nota && item)
                    }
                    scroll={{ x: 900 }}
                    pagination={false}
                    rowClassName={(record, index) =>
                      index % 2 === 0 ? "table-row-dark" : "table-row-light"
                    }
                    summary={(pageData) => {
                      // Calcula el total de notas en todas las páginas
                      const total = pageData.reduce((acc, item) => acc + item.nota, 0);
                      return (
                        <>
                          <Table.Summary.Row>
                            <Table.Summary.Cell index={0} colSpan={2}>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={1}>
                              Total:
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2}>
                              <span>{total}</span>
                            </Table.Summary.Cell>
                          </Table.Summary.Row>
                        </>
                      );
                    }}
                  />
                  <div className="col-12">
                    <div className="d-flex justify-content-md-end">
                      <Button
                        className="button-azul-radius order-1 mb-0"
                        type="primary"
                        onClick={async () => {
                          setTimeout(() => {
                          window.location.reload();
                      }, 500);
                        }}
                      >
                        GUARDAR
                      </Button>
                      <Button
                        className="button-gray-ghost me-2 order-0 mb-0"
                        style={{ border: "none" }}
                        onClick={() => {
                          props.setVisible(false);
                        }}
                      >
                        CANCELAR
                      </Button>
                    </div>
                  </div>
                </Content>
              </Content>
            </Layout>
          </div>
        </div>
      )}
    </div>
  );
}
